import React, { useEffect, useState } from "react";
import DeleteMemberModal from "../../../../components/common/modalMember";
import { Image, Space, message, Table as AntTable } from "antd";
import AddTypeCard from "../../business-types/manage-types/AddTypeCard";
import Button from "../../../../components/common/button";

import Table from "../../../../components/common/table";
import View from "../../../../assets/icons/view.svg";
import colors from "../../../../share/constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubCategories } from "../../../../store/slices/subCategorySlice";
import { ApartmentOutlined, DeleteFilled, MenuOutlined } from "@ant-design/icons";
import SubCategoryChildModal from "./subCategoryChildModal";
import { updateSubserviceCategory, updateSubcategoriesOrder } from "../../../../api/service";
import Trash from "../../../../assets/icons/trash.svg";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableSubCategoryRow = ({ children, ...props }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props['data-row-key'],
  });

  const style = {
    ...props.style,
    transform: CSS.Transform.toString(transform),
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  return (
    <tr {...props} ref={setNodeRef} style={style}>
      {React.Children.map(children, (child, index) => {
        if (index === 0 && child) {
          return React.cloneElement(child, {
            ...child.props,
            children: (
              <div {...attributes} {...listeners} style={{ cursor: 'grab', display: 'inline-block' }}>
                <MenuOutlined style={{ color: colors.primaryPurple }} />
              </div>
            ),
          });
        }
        return child;
      })}
    </tr>
  );
};

const SubCategory = () => {
  const [result, setResult] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [editValues, setEditValues] = useState();
  const [deleteId, setDeleteId] = useState();
  const [addType, setAddType] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddTypeModalOpen, setIsAddTypeModalOpen] = useState(false);
  const [childModal, setChildModalOpen] = useState(false);

  const dispatch = useDispatch();

  const {
    isLoading: loading,
    res: subCategories,
    error,
  } = useSelector((state) => state?.subCategory);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  // useEffect(() => {
  //   dispatch(fetchSubCategories());
  // }, []);

  useEffect(() => {
    if (subCategories) {
      // Sort by order if available, otherwise maintain current order
      const sorted = [...subCategories].sort((a, b) => {
        const orderA = a.order !== undefined ? a.order : Infinity;
        const orderB = b.order !== undefined ? b.order : Infinity;
        return orderA - orderB;
      });
      setResult(sorted);
    }
  }, [subCategories]);

  useEffect(() => {
    dispatch(fetchSubCategories());
  }, [addType, isModalOpen]);

  const YesClickHandler = async() => {
    const deleteCategory = await updateSubserviceCategory(deleteId, {
      isDelete: true,
    });
    if(deleteCategory)
    {
      message.success("Sub Category Deleted Successfully");
      setDeleteId(null);
    }
    setIsModalOpen(false);
  };
  const hideModal = () => {
    setIsModalOpen(false);
  };

  const handleAddBusiness = () => {
    setAddType(true);
    setEditValues(null);
    setIsAddTypeModalOpen(true);
  };

  const handleEditBusiness = (values) => {
    setAddType(true);
    setEditValues(values);
    setIsAddTypeModalOpen(true);
  };

  const handleDeleteCategory = (values) => {
    setIsModalOpen(true);
    setDeleteId(values?._id);
  };

  const handleSubCategoryChild = (el) => {
    setSelectedId(el);
    setChildModalOpen(true);
  };

  const handleSubCategoryDragEnd = async (event) => {
    const { active, over } = event;

    if (active.id !== over?.id && over) {
      const oldIndex = result.findIndex((item) => item._id === active.id);
      const newIndex = result.findIndex((item) => item._id === over.id);

      if (oldIndex !== -1 && newIndex !== -1) {
        const newResult = arrayMove(result, oldIndex, newIndex);
        setResult(newResult);

        // Update order in backend
        const orderUpdates = newResult.map((item, index) => ({
          id: item._id,
          order: index + 1,
        }));

        try {
          // Backend expects an object with 'items' field
          await updateSubcategoriesOrder({ subcategories: orderUpdates });
          message.success("Subcategory order updated successfully");
          dispatch(fetchSubCategories());
        } catch (error) {
          message.error("Failed to update subcategory order");
          // Revert on error
          setResult(result);
        }
      }
    }
  };

  const columns = [
    {
      title: "",
      key: "sort",
      width: 50,
      render: () => <MenuOutlined style={{ color: colors.primaryPurple }} />,
    },
    {
      title: "Category Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Category Image",
      dataIndex: "image",
      key: "image",
      render: (text, record) => (
        <>
          {record?.image ? (
            <Space>
              <Image
                src={record?.image}
                width={80}
                height={50}
                preview={true}
                alt="attachment"
                className="rounded object-cover"
              />
            </Space>
          ) : (
            <>N/A</>
          )}
        </>
      ),
    },
    {
      title: "Banner",
      dataIndex: "banner",
      key: "banner",
      render: (text, record) => (
        <>
          {record?.banner?.imageUrl ? (
            <Space direction="vertical" size="small">
              <Image
                src={record?.banner?.imageUrl}
                width={80}
                height={50}
                preview={true}
                alt="banner"
                className="rounded object-cover"
              />
              <span className="text-xs text-gray-500">
                {record?.banner?.clickAction === "service" 
                  ? "Service Link" 
                  : record?.banner?.clickAction === "link" 
                  ? "External Link" 
                  : "No Action"}
              </span>
            </Space>
          ) : (
            <>N/A</>
          )}
        </>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      width: 150,
      render: (ele) => (
        <Space size="middle">
          <div
            className="w-4 m-auto grid items-center justify-center h-4 rounded-full bg-lightLavender cursor-pointer"
            onClick={() => handleEditBusiness(ele)}
          >
            <img src={View} alt="View" />
          </div>
          <div
            className="w-4 m-auto grid items-center justify-center h-4 rounded-full bg-lightLavender cursor-pointer"
            onClick={() => handleSubCategoryChild(ele)}
          >
            <ApartmentOutlined />
          </div>
          <div
            className="flex items-center justify-center w-4 h-4  rounded-full bg-lightLavender cursor-pointer"
            onClick={() => handleDeleteCategory(ele)}
          >
            <img src={Trash} alt="View" />
          </div>
        </Space>
      ),
    },
  ];
  return (
    <div className="grid gap-2 w-full">
      <div className="flex justify-end">
        <div className="mr-2">
          <Button
            title="Add New Category"
            className="w-18 h-3.8"
            color={colors.primaryPurple}
            borderRadius={5}
            onClick={handleAddBusiness}
          />
        </div>
      </div>

      <div>
        <div className="container p-2">
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleSubCategoryDragEnd}
          >
            <SortableContext
              items={result.map((item) => item._id)}
              strategy={verticalListSortingStrategy}
            >
              <AntTable
                dataSource={result}
                columns={columns}
                rowKey="_id"
                pagination={false}
                loading={loading}
                components={{
                  body: {
                    row: SortableSubCategoryRow,
                  },
                }}
                className="shadow-md rounded-md"
                rowClassName="custom-row"
              />
            </SortableContext>
          </DndContext>
        </div>
      </div>

      {isModalOpen && (
        <DeleteMemberModal
          title="Delete Sub Category"
          text="Are you sure you want to delete this sub category?"
          onCancel={hideModal}
          onOk={YesClickHandler}
        />
      )}

      <AddTypeCard
        visible={isAddTypeModalOpen}
        onClose={() => {
          setIsAddTypeModalOpen(false);
          dispatch(fetchSubCategories());
        }}
        editValues={editValues}
        category={false}
        subservice={true}
      />

      <SubCategoryChildModal
        visible={childModal}
        data={selectedId}
        onCancel={() => {
          setChildModalOpen(false);
          dispatch(fetchSubCategories());
        }}
        category={false}
      />
    </div>
  );
};
export default SubCategory;
